// extracted by mini-css-extract-plugin
export var dataCell = "_pv-2";
export var dataRow = "_pv-0";
export var headerRow = "_pv-1";